module.exports = __webpack_public_path__ + "static/media/comiciconhover.efed62d8.svg";